<div class="text-sm text-600 mb-3">
  What we know about this suburb, in our own words. <b>Internal</b> is for the team. <b>Public</b> is written for the website and will feed the suburb page once suburb content is built; until then it isn't shown anywhere.
</div>

<div *ngIf="error" class="err text-sm mb-2">{{ error }}</div>
<div *ngIf="loading" class="text-600 text-sm">Loading…</div>

<ng-container *ngIf="!loading">
  <div *ngIf="!notes.length && !draft" class="text-600 text-sm mb-2">Nothing yet.</div>

  <div *ngFor="let n of notes" class="note">
    <ng-container *ngIf="draft?.id !== n.id">
      <div class="flex align-items-center justify-content-between gap-2">
        <div class="flex align-items-center gap-2 min-w-0">
          <span class="vis" [class.public]="n.visibility === 'public'">{{ n.visibility }}</span>
          <span class="font-medium note-title">{{ n.title }}</span>
        </div>
        <span *ngIf="!readOnly" class="flex-shrink-0">
          <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-rounded p-button-sm" (click)="edit(n)" pTooltip="Edit"></button>
          <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-sm p-button-danger" (click)="remove(n)" pTooltip="Delete"></button>
        </span>
      </div>
      <div class="body">{{ n.body }}</div>
      <div class="meta text-xs text-500">
        <ng-container *ngIf="n.source || n.sourceUrl">Source:
          <a *ngIf="safeUrl(n.sourceUrl) as href; else plainSource" [href]="href" target="_blank" rel="noopener noreferrer">{{ n.source || href }}</a>
          <ng-template #plainSource>{{ n.source }}</ng-template> ·
        </ng-container>
        {{ n.updatedBy || n.createdBy || 'someone' }}, {{ n.updatedAt | date: 'd MMM y' }}
      </div>
    </ng-container>
    <ng-container *ngIf="draft?.id === n.id">
      <ng-container *ngTemplateOutlet="form"></ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="draft && draft.id === null">
    <div class="note"><ng-container *ngTemplateOutlet="form"></ng-container></div>
  </ng-container>

  <button *ngIf="!draft && !readOnly" pButton type="button" class="p-button-sm p-button-outlined mt-2" icon="pi pi-plus" label="Add a note" (click)="add()"></button>
</ng-container>

<ng-template #form>
  <div *ngIf="draft" class="note-form">
    <p-selectButton [options]="visibilities" optionLabel="label" optionValue="value" [(ngModel)]="draft.visibility"></p-selectButton>
    <input pInputText class="w-full mt-2" placeholder="Title (optional)" maxlength="255" [(ngModel)]="draft.title" />
    <textarea pInputTextarea class="w-full mt-2" rows="5" placeholder="What we know" maxlength="10000" [(ngModel)]="draft.body"></textarea>
    <div class="flex gap-2 mt-2">
      <input pInputText class="flex-1 min-w-0" placeholder="Source (who / what)" maxlength="500" [(ngModel)]="draft.source" />
      <input pInputText class="flex-1 min-w-0" placeholder="Source link (https://…)" maxlength="1000" [(ngModel)]="draft.sourceUrl" />
    </div>
    <div class="flex justify-content-end gap-2 mt-2">
      <button pButton type="button" class="p-button-text p-button-sm" label="Cancel" (click)="cancel()"></button>
      <button pButton type="button" class="p-button-sm" label="Save" icon="pi pi-check" [loading]="saving" [disabled]="!(draft.body || '').trim()" (click)="save()"></button>
    </div>
  </div>
</ng-template>
